// react
import { useContext, useEffect, useState } from 'react';

// context
import { ContextLoans, ContextProject } from '../../Project.context';

// types
import { Project } from '../../../../../@types';

// i18next
import { useTranslation } from 'react-i18next';

// mui
import { Alert, Container, Grid, Typography } from '@mui/material';

// tables
import { TableFinancingSources } from '../../../../tables/cards/TableFinancingSources/TableFinancingSources';

// pages
import { SummaryFinancingSources } from '../../../../ui/SummaryFinancingSources/SummaryFinancingSources';

// fields
import { SelectCurrency } from '../../../../fields/SelectCurrency/SelectCurrency';

// props
export interface LoansProps {
	hasSummary?: boolean;
	project: Project;
}

export const Loans = ({ hasSummary = true, project }: LoansProps) => {
	// hooks
	const { t } = useTranslation();

	// context
	const { isLoadingLoans, loans } = useContext(ContextLoans);
	const { isOnboarded } = useContext(ContextProject);

	// state
	const [currency, setCurrency] = useState('');

	// vars
	const numOfLoansToEnable = loans.reduce((num, loan) => {
		return loan.status === 'DISABLED' ? num + 1 : num;
	}, 0);

	let currencies: string[] = [];

	for (let i = 0; i < loans.length; i++) {
		currencies.push(loans[i].currency);
		for (let a = 0; a < loans[i].conversions.length; a++) {
			if (!currencies.includes(loans[i].conversions[a].currency)) {
				currencies.push(loans[i].conversions[a].currency);
			}
		}
	}

	currencies = [...new Set(currencies)].sort();

	// set currency when loans change
	useEffect(() => {
		if (loans.length) {
			setCurrency(loans[0].currency);
		}
	}, [loans]);

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Grid alignItems="flex-end" container spacing={2}>
						<Grid item xs={12} md={true}>
							<Typography variant="h2">{t('financingSources')}</Typography>
						</Grid>
						<Grid item xs={12} md={3} lg={2}>
							<SelectCurrency
								currencies={currencies}
								hasLabel={false}
								onChange={(e) => {
									const { value } = e.target as HTMLInputElement;
									setCurrency(value);
								}}
								value={currency}
							/>
						</Grid>
					</Grid>
				</Grid>
				{project.status === 'PENDING' && (
					<Grid item xs={12}>
						<Alert severity="warning" variant="outlined">
							{t('alert.loansCannotBeEnabled')}
						</Alert>
					</Grid>
				)}
				{project.status === 'ENABLED' && numOfLoansToEnable > 0 && (
					<Grid item xs={12}>
						<Alert severity="info" variant="outlined">
							{t('alert.loansToEnable')}
						</Alert>
					</Grid>
				)}
				{hasSummary && (
					<Grid item xs={12}>
						<SummaryFinancingSources currency={currency} loans={loans} />
					</Grid>
				)}
				<Grid item xs={12}>
					<TableFinancingSources
						currency={currency}
						hasFilters={isOnboarded}
						isLoading={isLoadingLoans}
						loans={loans}
					/>
				</Grid>
			</Grid>
		</Container>
	);
};
